import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { createStaticSlider } from "./sliders";
let map;
let infoWindow;
const clusterRenderer = {
    render(cluster) {
        const count = cluster.count;
        const position = cluster.position;
        const svg = window.btoa(`
            <svg fill="#17454e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                <circle cx="120" cy="120" opacity=".8" r="60" />
                <circle cx="120" cy="120" opacity=".3" r="80" />
                <circle cx="120" cy="120" opacity=".2" r="100" />
                <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="45" dominant-baseline="middle" font-family="roboto,arial,sans-serif">
                    ${count}
                </text>
            </svg>
        `);
        return new google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(75, 75),
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
    }
};
export function initMap() {
    const mapEl = document.getElementById("map-results");
    if (!mapEl)
        return;
    map = new google.maps.Map(mapEl, {
        zoom: 6,
        center: { lat: 6.9169505, lng: -73.707737 },
        gestureHandling: 'greedy', // allows zooming without the ctrl key
    });
    infoWindow = new google.maps.InfoWindow({
        content: "",
    });
}
export function initHomeMap() {
    const mapEl = document.getElementById("homeMapRender");
    if (!mapEl)
        return;
    map = new google.maps.Map(mapEl, {
        zoom: 6,
        center: { lat: 6.9169505, lng: -73.707737 },
        gestureHandling: 'greedy', // allows zooming without the ctrl key
    });
    infoWindow = new google.maps.InfoWindow({
        content: "",
    });
}
let markers = [];
let markerClusterer;
export function deleteMarkers() {
    if (!markers.length)
        return;
    markers.forEach(marker => {
        marker.setMap(null);
        if (markerClusterer) {
            markerClusterer.removeMarker(marker);
        }
    });
    markers = [];
}
export function loadMarker(locations, labelsMap, idMap) {
    if (!map)
        return;
    google.maps.event.addListenerOnce(map, 'idle', () => {
        deleteMarkers();
        let markerBounds = new google.maps.LatLngBounds();
        markers = locations.map((position, i) => {
            const mapID = idMap[i];
            const label = labelsMap[i];
            const marker = new google.maps.Marker({
                position,
                icon: "/themes/custom/ev_theme/assets/images/pin-map-2.png",
                map
            });
            markerBounds.extend(position);
            marker.addListener("click", () => {
                infoWindow.setContent(label);
                infoWindow.open({ anchor: marker, map });
                setTimeout(() => {
                    const cardMap = document.getElementById('splide-map-' + mapID);
                    if (cardMap) {
                        createStaticSlider(cardMap, {
                            perPage: 1,
                        }, { lazy: true });
                    }
                }, 300);
            });
            return marker;
        });
        markerClusterer = new MarkerClusterer({
            map,
            markers,
            renderer: clusterRenderer
        });
        map.fitBounds(markerBounds);
        setTimeout(() => {
            google.maps.event.trigger(map, 'resize');
        }, 200);
    });
}
export function getMapInstance() {
    return map !== null && map !== void 0 ? map : null;
}
